import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/userContext";
import { baseUrl } from "../../../config/config";
import { getShortName } from './../../../utils/name.formate';
import { convertDate } from "../../../utils/date.formate";
import './avatar.scss';
import { short } from "../../../utils/messageStatus";

const Avatar = ({fiantso, useremail, chatRoomId}) => {
    const {userInfo} = useContext(Context);
    const [message, setMessage] = useState(null)
   
    const messageInfo = (messagId) => {
        if(messagId === 0){
            setMessage(null)
        }
        else{
            axios.get(`${baseUrl}/message/${chatRoomId}`)
            .then(res => {
                if(res.data.length === 0){
                    setMessage(null)
                  }
                  else{
                    const derniereValeur = res.data[res.data.length - 1];
                    setMessage(derniereValeur);
                  }
            })
            .catch(err  => {
                console.log(err)
            })
        }
    }
   
    useEffect(() => {
      if(chatRoomId) messageInfo(chatRoomId);
    }, [chatRoomId])
    
    return (
        <div className="avatar-container">
            <div className="avatar-image">
                <span>{fiantso && getShortName(fiantso)}</span>
            </div>
    
            <div className="avatar-body">
                <div className="avatar-name">{fiantso && fiantso}</div>
                <div className="avatar-message">
                    {message ? (
                    <>
                        <span>{userInfo?.id === message?.sender.id && <u>Izaho:</u>}</span>
                        {short(message?.content)}
                    </>
                    ) : (
                    <span style={{ color: '#AAA' }}>Tsy misy somaiso</span>
                    )}
                </div>
            </div>
    
            <div className="date-message">
                {message && <span>{convertDate(message?.createdAt)}</span>}
            </div>
        </div>
    );
}

export default Avatar;